import {TTheme} from '../model/store.ts';

export const applyTheme = (theme: TTheme) => {
  document.documentElement.style.setProperty('color-scheme', theme);
  document.body.style.removeProperty('color-scheme');
};
